import MUITd from '@mui/material/TableCell';
import React from 'react';

import { tableMapper } from '~/common/components/PropertyMappers/tableMapper';

type TdProps = React.ComponentProps<typeof MUITd> & {
  align?: 'center' | 'inherit' | 'justify' | 'left' | 'right';
  children?: React.ReactNode;
  classes?: any;
  component?: React.ReactNode;
  padding?: 'checkbox' | 'none' | 'normal';
  scope?: string;
  size?: 'medium' | 'small' | string;
  sortDirection?: 'asc' | 'desc' | boolean;
  variant?: 'body' | 'footer' | 'head' | string;
};

const Td = React.forwardRef<any, TdProps>(({ children, ...props }, ref) => {
  const tableProps = tableMapper(props);

  return (
    <MUITd ref={ref} {...tableProps}>
      {children}
    </MUITd>
  );
});

Td.displayName = 'Td';

export default Td;
